import React, { Component } from 'react'
import modalType from './ModalHOC'
import TextField from 'material-ui/TextField'
import { ALertHeaderText, AlertText, ConfirmText } from './styles'
import IconButton from 'material-ui/IconButton'
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import Clear from 'material-ui/svg-icons/content/clear'
import UncheckedIcon from 'material-ui/svg-icons/toggle/check-box-outline-blank'
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton'
import UncheckedRadioButton from 'material-ui/svg-icons/toggle/radio-button-unchecked'
import { FormattedMessage } from 'react-intl'
import Divider from 'material-ui/Divider'
import changeList from './InviteListHOC'
import Checkbox from 'material-ui/Checkbox'
import { ListItem } from 'material-ui/List'
import { getToken, isSentry } from '../../../lib'
import config from '../../../config/config'

const ChangingList = changeList(ListItem)

export class InviteModal extends Component {
  state = {
    name: '',
    email: '',
    role: 'student',
    nameError: '',
    emailError: ''
  }

  sendInvite = e => {
    e.preventDefault()
    const {name, email, role} = this.state
    const token = getToken()
    const conferenceId = this.props.selectConferenceId
    if (name.length === 0 && email.length === 0) {
      return this.setState({nameError: true, emailError: true})
    }

    if (name.length === 0 || email.length === 0) {
      if (name.length === 0 && email.length !== 0) {
        return this.setState({nameError: true, emailError: false})
      } else if (name.length !== 0 && email.length === 0) {
        return this.setState({nameError: false, emailError: true})
      }
    }
    this.props.addParticipant(token, name, email, role, conferenceId)
    this.props.handleClose()
    // this.props.snackbarOpen(
    //   <div>
    //     {name}
    //     <FormattedMessage id="inviteModal.invited" />
    //   </div>
    // );
  }

  handleRoleChange = (e, value) => this.setState({role: value})
  handleChange = (e, purpose) => {
    switch (purpose) {
      case 'name':
        return this.setState({name: e.target.value})
      case 'email':
        return this.setState({email: e.target.value})
      default:
        return console.error('Error')
    }
  }

  render () {
    return (
      <div>
        <div className="flex justify-between items-center">
          <ALertHeaderText>
            <FormattedMessage id="inviteModal.inviteParticipant"/>
          </ALertHeaderText>
          <div>
            <IconButton
              onTouchTap={this.props.handleClose}
              iconStyle={{fill: '#afb8c5'}}
            >
              <Clear/>
            </IconButton>
          </div>
        </div>
        <div>
          <form autoComplete="off" onSubmit={this.sendInvite}>
            <div className="mb4">
              <TextField
                hintText="Jon Doe"
                onChange={e => this.handleChange(e, 'name')}
                errorText={
                  this.state.nameError ? (
                    <FormattedMessage id="login.requiredField"/>
                  ) : null
                }
                value={this.state.name}
                floatingLabelText={<FormattedMessage id="inviteModal.name"/>}
                fullWidth
              />
              <TextField
                hintText="abc@abc.com"
                onChange={e => this.handleChange(e, 'email')}
                errorText={
                  this.state.nameError ? (
                    <FormattedMessage id="login.requiredField"/>
                  ) : null
                }
                value={this.state.email}
                floatingLabelText={<FormattedMessage id="login.emailLable"/>}
                type="email"
                fullWidth
              />
            </div>
            <div className="mb4 flex items-center justify-between">
              <RadioButtonGroup
                onChange={this.handleRoleChange}
                valueSelected={this.state.role}
                name="shipSpeed"
                defaultSelected="student"
                className="w-90"
                style={{fill: 'red'}}
              >
                <RadioButton
                  value="student"
                  label={<FormattedMessage id="inviteModal.student"/>}
                  iconStyle={{fill: '#45CE90'}}
                  uncheckedIcon={
                    <UncheckedRadioButton style={{fill: '#6B7C93'}}/>
                  }
                  style={{paddingBottom: '1rem'}}
                  labelStyle={{color: '#6B7C93'}}
                />
                <RadioButton
                  value="teacher"
                  label={<FormattedMessage id="inviteModal.teacher"/>}
                  iconStyle={{fill: '#45CE90'}}
                  uncheckedIcon={
                    <UncheckedRadioButton style={{fill: '#6B7C93'}}/>
                  }
                  style={{paddingBottom: '1rem'}}
                  labelStyle={{color: '#6B7C93'}}
                />
              </RadioButtonGroup>
            </div>
            <div className="flex justify-end mb4">
              <FlatButton
                label={<FormattedMessage id="loggedInNavigation.cancel"/>}
                onTouchTap={this.props.handleClose}
              />
              <RaisedButton
                type="submit"
                backgroundColor="#FCCE42"
                label={<FormattedMessage id="inviteModal.invite"/>}
              />
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export class ImporListModal extends Component {
  state = {
    selectedItems: 0,
    members: 0,
    selectAll: false,
    selectedIds: []
  }

  handleSelection = (isInputChecked, listMembers, contactId) => {
    let {selectedItems, members, selectAll, selectedIds} = this.state
    if (isInputChecked) {
      selectedItems = selectAll ? 0 : selectedItems + 1
      members = selectAll ? 0 : members + parseInt(listMembers, 10)
      selectedIds.push(contactId)
    } else {
      selectedItems = selectAll ? 0 : selectedItems - 1
      members = selectAll ? 0 : members - parseInt(listMembers, 10)
      const index = selectedIds.indexOf(contactId)
      if (index > -1) {
        selectedIds.splice(index, 1)
      }
    }
    this.setState({selectedItems, members, selectAll: false, selectedIds})
  }

  handleCheck = (e, isInputChecked) => {
    let totalMembers = 0
    let ids = []
    this.props.contacts.map(val => {
      totalMembers += val.total
      ids.push(val.id)
      return totalMembers
    })
    if (isInputChecked) {
      this.setState({
        selectAll: isInputChecked,
        members: totalMembers,
        selectedItems: this.props.contacts.length,
        selectedIds: ids
      })
    } else {
      this.setState({
        selectAll: isInputChecked,
        members: 0,
        selectedItems: 0,
        selectedIds: []
      })
    }
  }

  sendInvite = () => {
    const token = getToken()
    this.state.selectedIds.forEach(val => {
      this.props.importParticipants(token, val, this.props.selectConferenceId)
    })
    this.props.handleClose()
    this.props.snackbarOpen(
      <div>
        {this.state.selectedItems}
        <FormattedMessage id="inviteModal.listWith"/>
        {this.state.members}
        <FormattedMessage id="inviteModal.imported"/>
      </div>
    )
  }

  render () {
    return (
      <div>
        <div className="flex justify-between mt3 mb3">
          <ALertHeaderText>
            <ListItem
              primaryText={<FormattedMessage id="inviteModal.shareToImport"/>}
              leftCheckbox={
                <Checkbox
                  checked={this.state.selectAll}
                  onCheck={this.handleCheck}
                  iconStyle={{fill: '#29B87A'}}
                  uncheckedIcon={<UncheckedIcon style={{fill: '#6B7C93'}}/>}
                />
              }
              innerDivStyle={{
                fontSize: 20,
                color: 'rgba(50, 50, 93, 0.7)'
              }}
            />
          </ALertHeaderText>
          <div>
            <IconButton
              onTouchTap={this.props.handleClose}
              iconStyle={{fill: 'rgba(50, 50, 93, 0.7)'}}
            >
              <Clear/>
            </IconButton>
          </div>
        </div>
        <div className="overflow-auto" style={{height: '40vh'}}>
          {this.props.isFetchingList ? (
            <div className="flex h-100 justify-center items-center">
              <span>Fetching list</span>
            </div>
          ) : (
            this.props.contacts.map((val, index) => (
              <div key={index}>
                <Divider/>
                <ChangingList
                  data={val}
                  onNestedListToggle={this.handleSelection}
                  initiallyOpen={this.state.selectAll}
                  innerDivStyle={{
                    fontSize: 16,
                    color: '#6B7C93'
                  }}
                  hoverColor="#d9d9d9"
                />
              </div>
            ))
          )}
        </div>
        {this.state.selectedItems >= 1 ? (
          <div
            className="pa4 flex justify-between items-center"
            style={{borderTop: '1px solid #6B7C93'}}
          >
            <div>
              <div style={{fontSize: 20, color: '#32325D'}}>
                {this.state.selectedItems}
                <FormattedMessage id="inviteModal.listLelected"/>
              </div>
              <div style={{fontSize: 12, color: '#6B7C93'}}>
                {this.state.members}
                <FormattedMessage id="inviteModal.membersSelected"/>
              </div>
            </div>
            <div className="flex justify-end">
              <FlatButton
                label={<FormattedMessage id="loggedInNavigation.cancel"/>}
                onTouchTap={this.props.handleClose}
              />
              <RaisedButton
                className="ml2"
                backgroundColor="#45CE90"
                onTouchTap={this.sendInvite}
                labelStyle={{color: '#FFFFFF'}}
                label={<FormattedMessage id="seminarActions.import"/>}
              />
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    )
  }
}

export const InviteAllModal = ({
                                 actionForAll,
                                 handleClose,
                                 totalParticipants
                               }) => {
  const handleTouchTap = e => {
    handleClose()
    actionForAll(
      'invite',
      <div>
        <FormattedMessage id="inviteModal.sentInvite"/>
        {totalParticipants}
        <FormattedMessage id="inviteModal.participants"/>
      </div>
    )
  }

  return (
    <div>
      <div className="flex justify-between items-center">
        <ALertHeaderText>
          {totalParticipants > 0 ? (
            <div>
              <FormattedMessage id="inviteModal.inviteAll"/>
              {totalParticipants}
              <FormattedMessage id="inviteModal.participantToSeminar"/>
            </div>
          ) : (
            <FormattedMessage id="inviteModal.noParticipants"/>
          )}
        </ALertHeaderText>
        <div>
          <IconButton onTouchTap={handleClose} iconStyle={{fill: '#afb8c5'}}>
            <Clear/>
          </IconButton>
        </div>
      </div>
      {totalParticipants > 0 ? (
        <ConfirmText className="mt3 mb3">
          <FormattedMessage id="inviteModal.sureNotify"/>
          {totalParticipants}
          <FormattedMessage id="inviteModal.participantToSeminar"/>
        </ConfirmText>
      ) : (
        ''
      )}
      <div className="flex justify-end">
        <div className="w4">
          <FlatButton
            label={<FormattedMessage id="loggedInNavigation.cancel"/>}
            fullWidth
            labelStyle={{color: '#AFB8C4'}}
            onTouchTap={handleClose}
          />
        </div>
        <div className="ml2 w4">
          <FlatButton
            disabled={totalParticipants === 0}
            label={<FormattedMessage id="inviteModal.all"/>}
            hoverColor="#1e8257"
            style={{opacity: totalParticipants === 0 ? 0.3 : 1}}
            fullWidth
            backgroundColor="#29B87A"
            labelStyle={{color: '#FFFFFF'}}
            onTouchTap={handleTouchTap}
          />
        </div>
      </div>
    </div>
  )
}

export const RemoveAllModal = ({
                                 actionForAll,
                                 handleClose,
                                 totalParticipants
                               }) => {
  const handleTouchTap = e => {
    handleClose()
    actionForAll(
      'delete',
      <div>
        <FormattedMessage id="inviteModal.deletedAllMessage"/>
      </div>
    )
  }

  return (
    <div>
      <div className="flex justify-between items-center">
        <ALertHeaderText>
          {totalParticipants > 0 ? (
            <div>
              <FormattedMessage id="seminarActions.removeModal.heading"/>
              {totalParticipants}
              <FormattedMessage id="inviteModal.participantToSeminar"/>
            </div>
          ) : (
            <FormattedMessage id="inviteModal.noParticipants"/>
          )}
        </ALertHeaderText>
        <div>
          <IconButton onTouchTap={handleClose} iconStyle={{fill: '#afb8c5'}}>
            <Clear/>
          </IconButton>
        </div>
      </div>
      {totalParticipants > 0 ? (
        <AlertText className="mt3 mb3">
          <FormattedMessage id="inviteModal.sureRemoveAll"/>
        </AlertText>
      ) : (
        ''
      )}
      <div className="flex justify-end">
        <div className="w4">
          <FlatButton
            label={<FormattedMessage id="loggedInNavigation.cancel"/>}
            fullWidth
            onTouchTap={handleClose}
          />
        </div>
        <div className="ml2 w4">
          <FlatButton
            label={<FormattedMessage id="inviteModal.removeAll"/>}
            fullWidth
            disabled={totalParticipants === 0}
            style={{opacity: totalParticipants === 0 ? 0.3 : 1}}
            hoverColor="#ab1124"
            backgroundColor="#F01631"
            labelStyle={{color: '#FFFFFF'}}
            onTouchTap={handleTouchTap}
          />
        </div>
      </div>
    </div>
  )
}

export class PreviewModal extends Component {

  state = {
    subject: '',
    subject_default: '',
    body: '',
    body_default: '',
  }

  componentDidMount () {
    const token = getToken()
    return fetch(`${config.URI}/api/v1/email_template`, {
      method: 'GET',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      }
    })
      .then((temp) => temp.json())
      .then(res => {
        if (res.status === 'success') {
          this.setState({
            subject: res.data.subject,
            subject_default: res.data.subject_default,
            body: res.data.body,
            body_default: res.data.body_default,
          })
        } else {
          alert('サーバーとの接続にエラーが発生しました。')
        }
      })
      .catch((error) => {
        isSentry(error)
        alert('サーバーとの接続にエラーが発生しました。')
      })
  }

  setDefault () {
    this.setState({
      subject: this.state.subject_default,
      body: this.state.body_default
    })
  }

  save () {
    if ((this.state.subject == '') || (this.state.body == '')) {
      alert('件名と本文を入力してください。')
      return
    }
    const payload = {body: this.state.body, subject: this.state.subject}
    const token = getToken()
    return fetch(`${config.URI}/api/v1/email_template`, {
      method: 'PUT',
      headers: {
        'Authenticity-Token': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then((temp) => temp.json())
      .then(res => {
        if (res.status === 'success') {
          this.props.handleClose()
        } else {
          alert('サーバーとの接続にエラーが発生しました。')
        }
      })
      .catch((error) => {
        isSentry(error)
        alert('サーバーとの接続にエラーが発生しました。')
      })
  }

  render () {
    return (
      <div>
        <div className="flex justify-between items-center">
          <ALertHeaderText className="ttu">
            <FormattedMessage id="seminarActions.previewEmail"/>
          </ALertHeaderText>
          <div>
            <IconButton
              onTouchTap={this.props.handleClose}
              iconStyle={{fill: '#afb8c5'}}
            >
              <Clear/>
            </IconButton>
          </div>
        </div>
        <div className="pa4">
          <div>
            <div style={{fontSize: 20}}>
              <FormattedMessage id="previewModal.subject"/>
            </div>
            <form>
              <input
                style={{width: '40vh'}}
                type="text"
                value={this.state.subject}
                onChange={(e) => this.setState({subject: e.target.value})}
              />
            </form>

          </div>
          <div className="mt3">
            <div style={{fontSize: 20}}>
              <FormattedMessage id="previewModal.body"/>
            </div>
            <textarea
              style={{width: '40vh', height: '30vh'}}
              value={this.state.body}
              onChange={(e) => this.setState({body: e.target.value})}
            />
          </div>
          <div className="flex justify-center mt3">
            <FlatButton
              label={<FormattedMessage id="previewModal.save"/>}
              fullWidth
              labelStyle={{color: '#AFB8C4'}}
              onTouchTap={() => this.save()}
            />
          </div>
          <div className="flex justify-center mt3">
            <FlatButton
              label={<FormattedMessage id="previewModal.default"/>}
              fullWidth
              labelStyle={{color: '#AFB8C4'}}
              onTouchTap={() => this.setDefault()}
            />
          </div>
        </div>
      </div>
    )
  }
}

const Modal = ({children}) => <div>{children}</div>

export default modalType(Modal)



// WEBPACK FOOTER //
// ./src/components/Seminars/SeminarActions/Modals.js